import AdminList from "../components/AdminList";
import useAdminList from "../hooks/useAdminList";

function AdminListPage () {
    const UseAdminListProps = useAdminList();
    return <AdminList {...UseAdminListProps}/>

}

export default AdminListPage;